import {
    Container,
    Row,
    Col,
    Card
} from 'reactstrap';
import styles from './styles.module.scss';
import clsx from "classnames";
import PropTypes from "prop-types";
import Link from "next/link"
// import { parseISO, format } from 'date-fns';
import SourceFlowApplicationForm from "@sourceflow-uk/sourceflowapplicationform";
// import jobs from '@/.sourceflow/jobs.json';
import React, { useRef, useState, useEffect } from 'react';
import Button from "@/components/Button";
import EditableText from "@/components/EditableText";
import JobCard from "@/components/Shared/JobCard";
import JobApplicationForm from "@/components/Shared/JobApplicationForm";
import SocialShare from "@/components/Shared/SF_SocialShareCard_001";
import sourceflowEnums from "@/sourceflow.enums";

import { motion } from 'framer-motion';
import {init, track} from "fbq";

export default function JobDetails({
    className,
    global,
    page,
    pathPrefix,
    successPageUrl,
    job_heading_description,
    job_similar_jobs_description,
    job_apply_heading,

    looking_for_more_heading,
    looking_for_more_content,

    cta_title_1,
    cta_link_1,
    relatedJobs
}) {
    const sectionRef = useRef(null);
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        const options = {
            root: null,
            rootMargin: '0px',
            threshold: 0.1 // Adjust threshold as needed, make it smaller for more sensitive detection
        };

        const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    setIsVisible(true);
                    observer.unobserve(entry.target);
                }
            });
        }, options);

        observer.observe(sectionRef.current);

        // Cleanup function
        return () => {
            observer.disconnect();
        };
    }, []);

    useEffect(() => {
        const handleResize = () => {
            const mobileDevice = window.innerWidth <= 991; // Adjust threshold for mobile devices
            // setIsVisible(!mobileDevice); // Hide motion on mobile devices
        };

        handleResize(); // Call initially
        window.addEventListener('resize', handleResize);

        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const onSubmitDone = () => {
        init( '574554866614571');
        track('Purchase', {
            content_ids: [`0743ba8e-a6e0-4c4e-93ea-72163b12a2b4_${page.external_reference}`],
            content_type: 'product',
            value: 0.01,
            currency: 'EUR'
        });

        // Assuming getJsonItem is accessible here
        window.location.href = `${successPageUrl}?location=${encodeURIComponent(page.location)}&job_title=${encodeURIComponent(page.title)}&job_reference=${encodeURIComponent(page.external_reference)}`;
    };

    useEffect(() => {
        const addClassToButton = () => {
            const formElement = document.querySelector(`#sourceflow-form-${page.id}`);
            if (formElement) {
                const button = formElement.querySelector('button[type="submit"]');
                if (button) {
                    button.classList.add('application-btn-submit');
                }
            }
        };

        addClassToButton();
    }, [page.id]);

    return (
        page && (
            <section ref={sectionRef} className={clsx(className, styles.root)}>
                <Container>
                    <div className='d-block d-lg-flex gap-4 align-items-start'>
                        <div className='column left'>
                            <div className='post-content'>
                                <EditableText
                                    content={job_heading_description}
                                    path={`${pathPrefix}.heading`}
                                    global={global}
                                    tag={`h2`}
                                    className={`heading h4 mb-4`}
                                />
                                {page.description && (
                                    <div className="post-description" dangerouslySetInnerHTML={{ __html: page?.description }} />
                                )}
                            </div>
                            {/* <JobApplicationForm
                                job_apply_heading={job_apply_heading}
                                page={page}
                                global={global}
                                pathPrefix={pathPrefix}
                                className={`d-none d-lg-block`}
                            /> */}
                            <div className='post-application-overlays'>
                                <div className='post-application' id="apply-now">
                                    <div className='inner-post-application'>
                                        <EditableText
                                            content={job_apply_heading}
                                            path={`${pathPrefix}.apply_job.heading`}
                                            global={global}
                                            tag={`h3`}
                                            className={`heading h1 mb-4`}
                                        />
                                        <SourceFlowApplicationForm
                                            onSubmitDone={onSubmitDone}
                                            jobId={page.id}
                                            location={page.location}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='column right'>
                            <div>
                                <SocialShare
                                    pageTitle={`New Job Opening: ${page.title} ${page.location && (`in ${page.location}`)}`}
                                    pageUrl={`${sourceflowEnums.seo.baseURL}/jobs/${page.url_slug}`}
                                    blogPage={true}
                                    className={`blog-style social-share mb-5`}
                                />
                            </div>

                            {relatedJobs.length >= 1 && (
                                <div className='similar-jobs'>
                                    <EditableText
                                        content={job_similar_jobs_description}
                                        path={`${pathPrefix}.similar_jobs.heading`}
                                        global={global}
                                        tag={`h3`}
                                        className={`heading h4 mb-4`}
                                    />
                                    {/* {relatedJobs.map((post, index) => (
                                        <motion.div key={index} className='mb-4' initial={{ opacity: 0, y: 50 }} animate={isVisible ? { opacity: 1, y: 0 } : {}} transition={{ duration: 0.5, delay: index * 0.2 }}>
                                            <JobCard
                                                global={global}
                                                post={post}
                                            />
                                        </motion.div>
                                    ))} */}

                                    {relatedJobs.map((post, index) => {
                                        // Check if the current related job's title matches the main job's title
                                        if (post.title === page.title) {
                                            return null; // Skip rendering this job card
                                        }
                                        return (
                                            <motion.div key={index} className='mb-4' initial={{ opacity: 0, y: 50 }} animate={isVisible ? { opacity: 1, y: 0 } : {}} transition={{ duration: 0.5, delay: index * 0.2 }}>
                                                <JobCard
                                                    global={global}
                                                    post={post}
                                                    similar_jobs_unixtimestamp={true}

                                                />
                                            </motion.div>
                                        )

                                    })}
                                </div>
                            )}
                            <div className='looking-for-more'>
                                <EditableText
                                    content={looking_for_more_heading}
                                    path={`${pathPrefix}.looking_for_more.heading`}
                                    global={global}
                                    tag={`h4`}
                                    className={`h4`}
                                />
                                <EditableText
                                    content={looking_for_more_content}
                                    path={`${pathPrefix}.looking_for_more.content`}
                                    global={global}
                                    tag={`div`}
                                    className={``}
                                />
                                {cta_title_1 && (
                                    <Button
                                        text={`${cta_title_1}`}
                                        url={`${cta_link_1}`}
                                        className={`m-0 mt-3 tertiaryBtn w-100 justify-content-center`}
                                    // showArrow={false}
                                    />
                                )}
                            </div>
                        </div>
                    </div>
                </Container>
            </section >
        )
    )
}



JobDetails.defaultProps = {
    pathPrefix: "",
    className: "pt-5",
    successPageUrl: "/jobs/thank-you-for-applying"
};

JobDetails.propTypes = {
    pathPrefix: PropTypes.string,
    className: PropTypes.string,
    successPageUrl: PropTypes.string
};

// function getConsultant(job) {
//     return consultants.category_values.find((consultant) => {
//         return consultant?.email?.en?.toLowerCase() == job.consultant_email.toLowerCase()
//     });
// }